import { Box } from '@mui/material'

function PersonalSettings() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      Personal Settings
    </Box>
  )
}

export default PersonalSettings
